module.exports = __webpack_public_path__ + "static/media/blintz.43a606b8.png";